import { shopifyVariantDefaultTitle } from '~/lib/constants'

import { CardProductProps } from '~/components/UI/CardProduct'

import {
  fetchShopifyProductCard,
  serializeStoryblokData,
} from '~/data/product-card-data'

export * from './shopify-serializer'
export * from './storyblok-serializer'
export type {
  Media,
  SerializedProduct,
  StoryblokShopifyProduct,
  StoryblokShopifyProductVariant,
} from './types'

/**
 * Product cards serializer used to serialize product to be display as cards
 * @param data
 * @param locale
 * @returns serializedProduct[]
 */
export default async function serializeProductCard(
  data,
  locale,
): Promise<CardProductProps> {
  // Serialize Storyblok editorial data
  const content = serializeStoryblokData(data, locale)

  // Serialize shopify product data
  const product = await fetchShopifyProductCard({
    data,
    locale,
    inProductHeader: false,
    shouldFetchCollections: false,
    shouldFetchImages: false,
  })

  if (!product) return null

  return {
    defaultVariantId: product?.defaultVariant?.id ?? null,
    defaultVariantTitle:
      product.defaultVariant?.title !== shopifyVariantDefaultTitle
        ? product.defaultVariant?.title ?? null
        : null,
    defaultVariant: product?.defaultVariant ?? null,
    productName: content?.name ?? null,
    isSimpleProductPreOrder: product?.isSimpleProductPreOrder ?? false,
    categories: content?.categories ?? [],
    meanings: content?.meanings ?? [],
    hasMultipleVariants: !!(product.variants?.length > 1),
    availableForSale: product?.availableForSale ?? null,
    price: product?.priceFrom ?? null,
    compareAtPrice: product?.compareAtPrice ?? null,
    shopifyId: product?.shopifyId ?? null,
    ...content,
  }
}
